import BkPage from '../../Components/ui/BkPage';
import BkPanel from '../../Components/ui/BkPanel';
import BkButton from '../../Components/ui/BkButton';

export type GameNotFoundProps = {
  gameId?: string;
  reason?: 'not_found' | 'auth' | 'forbidden';
  message?: string;
};

export default function GameNotFound({
  gameId,
  reason = 'not_found',
  message,
}: GameNotFoundProps) {
  const title =
    reason === 'auth'
      ? 'Sign In Required'
      : reason === 'forbidden'
        ? 'Access Denied'
        : 'Game Not Found';

  const body =
    message ??
    (reason === 'auth'
      ? 'You must be signed in to view or play a game.'
      : reason === 'forbidden'
        ? 'Only seated players can view this game. Use matchmaking from Home to find a game.'
        : `Could not locate any game with the id of "${gameId}"`);

  return (
    <BkPage className="flex h-full items-center justify-center">
      <BkPanel className="w-full max-w-xl space-y-4 text-center">
        <h1 className="text-2xl font-bold uppercase tracking-wider text-bk-gold">
          {title}
        </h1>
        <p className="text-bk-muted">{body}</p>
        <div className="flex justify-center gap-2">
          <BkButton to="/" variant="secondary" size="sm">
            Home
          </BkButton>
          {reason === 'auth' ? (
            <BkButton to="/" variant="primary" size="sm">
              Sign in from Home
            </BkButton>
          ) : null}
        </div>
      </BkPanel>
    </BkPage>
  );
}
